// https://reactcommunity.org/react-transition-group/
import Transition from 'react-transition-group/Transition';

const duration = 300;

const transitionStyles = {
  entering: { opacity: 0 },
  entered:  { opacity: 1 },
};

const Slide = ({ in: inProp, children, isActive, bg, fg }) => (
  <Transition in={inProp} timeout={duration} mountOnEnter={true} unmountOnExit={true}>
    {(state) => (
      <div className="slide pabs fs" style={{
        transition: `opacity ${duration}ms ease-in-out`,
        opacity: 0,
        ...transitionStyles[state]
      }}>
        {children}
      </div>
    )}
  </Transition>
);

export default Slide



// WEBPACK FOOTER //
// ./app/javascript/packs/components/Slide.js